import { Permission } from 'types/permission';
import api from '../services/apis/api';

export const getPermissions = () => api.get<Permission[]>('/permission');
